import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthorizationProgressComponent } from './components/authorization-progress/authorization-progress.component';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    AuthorizationProgressComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
}
